export const config = {
  title: "Buqui Construction LLC",
  meta: {
    description:
      "Buqui Construction LLC provides comprehensive residential and commercial construction services in Miami, FL, including concrete, roofing, drywall, tile, electrical, plumbing, and remodeling.",
    keywords: [
      "Buqui Construction Miami",
      "Miami construction services",
      "roofing Miami FL",
      "concrete contractors Miami",
      "drywall stucco tile installation"
    ],
    author: "Buqui Construction LLC",
    canonicalUrl: "https://buquiconstruction.com/",
  },
  sections: {
    header: { businessName: "Buqui Construction LLC" },
    sectionB: {
      heroTitle: "Buqui Construction LLC",
      heroSubtitle: "Miami Construction & Remodeling Experts",
      learnAboutText: "Our Services",
      phoneNumber: "7865941228",
      phoneLabel: "(786) 594‑1228",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2190448800/photo/drywall-installers-working-in-kitchen-renovation.jpg?s=612x612&w=0&k=20&c=fsexnZL5oN4Yh18xFVpL8ohH48_s4DmLEEJCEZtIkTo=",
      cardData: [
        {
          title: "Concrete & Painting",
          description: "Driveways, patios, foundations, and decorative concrete.",
        },
        {
          title: "Roofing & Covering",
          description: "Roof installation, repairs, coverings & waterproofing.",
        },
        {
          title: "Electrical & Plumbing",
          description: "Complete system installs and service for homes and businesses.",
        },
      ],
      description:
        "Buqui Construction LLC is a trusted, full‑service construction contractor in Miami—serving residential and commercial clients with excellence in concrete, roofing, electrical, plumbing, drywall, tile and more.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From essential systems to finishing touches, we offer a full range of construction and remodeling services.",
      cards: [
        {
          title: "Stucco & Drywall",
          description: "Seamless walls and exterior finishes.",
          imageSrc: "https://media.istockphoto.com/id/1311906243/photo/a-man-with-two-spatulas-in-his-hands-applies-putty-very-close-up-selective-focus.jpg?s=612x612&w=0&k=20&c=49ERSUotfmj0QRrVrVHM63klFJzn3RlkuS-JVnRIlOY=",
          imageAlt: "Stucco Drywall Work",
        },
        {
          title: "Tile Installation",
          description: "Floor, wall, and bathroom tile craftsmanship.",
          imageSrc: "https://media.istockphoto.com/id/2155929361/photo/tile-installation.jpg?s=612x612&w=0&k=20&c=77xefLXsNMVLVOZYHLhCnjBfVXbY9dqBSn633OxW3kA=",
          imageAlt: "Tile Installation",
        },
        {
          title: "Remodeling & Construction",
          description: "Full-scale renovations and build-outs.",
          imageSrc: "https://media.istockphoto.com/id/2151912551/photo/building-contractor-talking-to-clients-renovating-their-house.jpg?s=612x612&w=0&k=20&c=QhL8-C4dGz4ATIhLTaFYD_tKjHTLAKWZIBsuBW_n-ms=",
          imageAlt: "Remodeling Construction",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Electrical & Plumbing",
        "Roofing & Waterproofing",
        "Concrete & Decorative Finishes",
        "Coverings & Foundation Work",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://buquiconstruction.com/wp-content/uploads/2025/06/Logo-Pagina.png",
        alt: "Buqui Construction Crew",
      },
      aboutText: [
        "Buqui Construction LLC is a Miami‑based construction firm dedicated to delivering quality, reliability, and clear communication on every project.",
        "We pride ourselves on craftsmanship, transparent pricing, and on‑time project completion for both homeowners and businesses.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Buqui Construction Logo",
      businessName: "Buqui Construction LLC",
      contact: {
        phone: "7865941228",
        phoneLabel: "(786) 594‑1228",
        email: "buqui305@gmail.com",
        website: "https://buquiconstruction.com/",
        address: "2945 NW 26th St, Miami, FL 33142",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "2945 NW 26th St, Miami, FL 33142",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d358178.123456789!2d-80.301!3d25.820!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b5a4b1234567%3A0xabcdef9876543210!2s2945+NW+26th+St%2C+Miami%2C+FL+33142!5e0!3m2!1sen!2sus!4v1718720000000!5m2!1sen!2sus",
    },
  },
};

export default config;
